import Vue from 'vue';

// 全局事件总线：用于跨组件通信（不依赖 $root/$parent）
export const eventBus = new Vue();